module.exports = __webpack_public_path__ + "img/iphone6s.7df592bf.jpg";